import { submitAssignment } from "../api";
export const submitAssignmentAction = async (
  userID,
  assignmentID,
  setUser
) => {
  try {
    const res = await submitAssignment(
      userID,
      assignmentID
    );
    setUser(res.data);
  } catch (err) {
    console.log(err);
  }
};
